module.exports = __webpack_public_path__ + "img/scrollTop-icon.c4d6f1e2.svg";